export default __webpack_public_path__ + "static/media/evalogo.96ad06ff.png";